module.exports = __webpack_public_path__ + "img/qrcode_for_gh_7e444c0c022f_344.64d615e8.jpg";